import { Modal } from 'antd-mobile'
import {
  snRequest,
  phoneConnect,
  roomEnterPasswd,
  loginBackend,
  favariteAdd,
  favariteDel,
} from '@/api/api'
import storage from '@/utils/storage'
import { getParameterByName, ToastFail, ToastSuccess } from '@/utils/utils'
import { getStore } from '@/store'
import { getFormatMessage } from '@/locales'
import { eventEmitter, eventEmitter_KEYS } from './eventEmitter'
import { getRoutes, history } from '@/router'
import $mqtt, { MQTT_MSG_KEYS } from '@/api/mqtt'
import { isTabConnectMode } from './connectHelper'

export async function getUserInfo() {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data
}

export async function getUserName() {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data && data.userName
}

export async function getMachineName() {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data && data.machineName
}

export async function getLinked() {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data && data.linked
}

export async function getType() {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data && data.type
}

export async function getName() {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data && data.name
}

export async function getToken() {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data && data.token
}

export async function getSN(): Promise<string> {
  return await storage.getItem(storage.KEYS.SN)
}

export async function getsn1(): Promise<string> {
  const data: any = await storage.getItem(storage.KEYS.userInfo)
  return data && data.sn1
}

export async function getColletionCode(): Promise<string> {
  return await storage.getItem(storage.KEYS.colletionCode)
}

export async function getLoginRoomModalTime(): Promise<number> {
  return await storage.getItem(storage.KEYS.loginRoomModalTime)
}

export async function initUserStatus() {
  const { userStore } = getStore()

  const token = await getToken()
  const code = await getColletionCode()
  const sn = await getSN()

  userStore.updateUserConnectStatus(!!token)
  userStore.colletionCode = code
  userStore.sn = sn
}

export async function initSN() {
  if (await getSN()) return

  const { userStore } = getStore()

  const data: any = await snRequest()
  await storage.setItem(storage.KEYS.SN, data.result)
  userStore.sn = data.result
}

export async function userConnect(
  codeOptions: string | Record<any, any>,
  obj?: object,
) {
  let params: any = null
  const intlMsg = getFormatMessage()
  const { userStore, headerStore } = getStore()
  const router = getRoutes()

  await initSN()

  if (typeof codeOptions !== 'string') {
    const phoneConnectParams: any = {}
    if (codeOptions.linkCode) {
      phoneConnectParams['linkCode'] = codeOptions.linkCode
    }
    if (codeOptions.tabname && codeOptions.linkCode1) {
      phoneConnectParams['tabname'] = codeOptions.tabname
      phoneConnectParams['linkCode1'] = codeOptions.linkCode1
    }
    if (codeOptions.tabCode) {
      phoneConnectParams['tabCode'] = codeOptions.tabCode
    }
    const { msgType, ...data } = await phoneConnect(phoneConnectParams)

    params = data
  } else {
    params = obj
  }

  if (headerStore.tableListModalType === 'loginSelect') {
    const data = await getUserInfo()
    params = {
      ...data,
      name: params.name,
    }
    headerStore.tableListModalType = 'changeTable'
  }

  storage.setItem(storage.KEYS.userInfo, params).then(() => {
    // 如果type=table,且name为空,然后通过弹出桌台选择列表
    if (params.type === 'table' && !params.name) {
      headerStore.updateTableListModalVisible()
      headerStore.tableListModalType = 'loginSelect'
      return
    }
    // 连接成功后，清除原来的订阅
    $mqtt.unsubscribeAll()
    // 每次phoneConnect成功后，都需要发送setLinkedId协议,方便服务器知道该手机连接对应的机器．
    $mqtt.send(MQTT_MSG_KEYS.setLinkedId, {
      linked_id: params.linked,
    })

    ToastSuccess(intlMsg['tips.success.connect'])
    userStore.updateUserConnectStatus()
    if (history.location.pathname === '/login') {
      router.home.pushSelf()
    }
    recordConnectTime()
  })
}

export async function autoUserConnect() {
  const linkCode = getParameterByName('linkCode')
  const tabname = getParameterByName('tabname')
  const linkCode1 = getParameterByName('linkCode1')
  const { userStore, headerStore } = getStore()

  if (isTabConnectMode()) {
    setTimeout(() => {
      if (history.location.pathname !== '/login') {
        showTabConnectModal({ linkCode })
      } else {
        userStore.updateModalConnecting(linkCode)
      }
    }, 0)
    return
  }

  if (linkCode) {
    if (tabname && !linkCode1) {
      showHallConnectModal({ linkCode, tabname })
      return
    }
    if (tabname && linkCode1) {
      userConnect({ linkCode, tabname, linkCode1 })
      return
    }

    userConnect({ linkCode })
  } else if (!userStore.userConnectStatus) {
    headerStore.updateUserDrawerVisible()
  }
}

export function showUserConnectModal({ cancelBtn = true } = {}) {
  const intlMsg = getFormatMessage()
  const callbackOrActions: any = [
    {
      text: intlMsg['btn.confirm'],
      onPress: (value: any) =>
        new Promise(async (resolve, reject) => {
          if (!value.trim()) return reject()
          await userConnect({ linkCode: value })
          return resolve()
        }),
    },
  ]

  cancelBtn && callbackOrActions.unshift({ text: intlMsg['btn.cancel'] })

  Modal.prompt(
    intlMsg['com.user.connect'],
    intlMsg['tips.warning.input-connect-code'],
    callbackOrActions,
  )
}

export function showHallConnectModal({
  cancelBtn = true,
  tabname = '',
  linkCode = '',
} = {}) {
  const intlMsg = getFormatMessage()
  const callbackOrActions: any = [
    {
      text: intlMsg['btn.confirm'],
      onPress: (value: any) =>
        new Promise(async (resolve, reject) => {
          if (!value.trim()) return reject()
          await userConnect({ linkCode, tabname, linkCode1: value })
          return resolve()
        }),
    },
  ]

  cancelBtn && callbackOrActions.unshift({ text: intlMsg['btn.cancel'] })

  Modal.prompt('连接大厅', '请输入大厅连接码', callbackOrActions)
}

export function showTabConnectModal({ cancelBtn = false, linkCode = '' } = {}) {
  const intlMsg = getFormatMessage()
  const callbackOrActions: any = [
    {
      text: intlMsg['btn.confirm'],
      onPress: (value: any) =>
        new Promise(async (resolve, reject) => {
          if (!value.trim()) return reject()
          await userConnect({ linkCode, tabCode: value })
          return resolve()
        }),
    },
  ]

  cancelBtn && callbackOrActions.unshift({ text: intlMsg['btn.cancel'] })

  Modal.prompt(
    intlMsg['tips.warning.input-connect-tab-code'],
    '',
    callbackOrActions,
  )
}

export async function showColletionCodeModal(tips = '') {
  const { userStore } = getStore()
  const intlMsg = getFormatMessage()
  const code = await getColletionCode()
  Modal.prompt(
    `${intlMsg['com.title.set']}${intlMsg['page.setting.collect-code']}`,
    tips,
    [
      { text: intlMsg['btn.cancel'] },
      {
        text: intlMsg['btn.confirm'],
        onPress: (val: string) => {
          storage.setItem(storage.KEYS.colletionCode, val.trim()).then(code => {
            ToastSuccess(intlMsg['tips.success.set'])
            eventEmitter.emit(eventEmitter_KEYS.updateColletionCode, code)
            userStore.colletionCode = code
          })
        },
      },
    ],
    'default',
    code,
  )
}

export async function activeFavoriteSong(
  source: { [key: string]: any },
  index: number,
  callback: Function,
) {
  const code = await getColletionCode()
  const intlMsg = getFormatMessage()
  const { fav } = source

  if (!code) {
    showColletionCodeModal(intlMsg['tips.warning.set-collect-code'])
    return
  }

  if (fav === '0') {
    const { result } = await favariteAdd({
      favariteId: code,
      songNumber: source.songNumber,
      songName: source.songName,
      singerName: source.singerName,
      lang: source.lang,
      mtv: source.mtv,
    })

    if (result === 'success') {
      ToastSuccess(intlMsg['tips.success.collect'])
    } else {
      ToastFail(intlMsg['tips.warning.collect'])
    }
  } else {
    await favariteDel({
      songNumber: source.songNumber,
      favariteId: code,
    })

    ToastSuccess(intlMsg['tips.success.handle'])
  }

  callback && callback(index, fav === '0')
  // eventEmitter.emit(eventEmitter_KEYS.refreshSongList)
}

export async function updateLoginRoomModalStatus(key: string) {
  await roomEnterPasswd({
    key,
  })
  storage.setItem(storage.KEYS.loginRoomModalTime, Date.now())
}

export async function userDisconnect() {
  const { headerStore, userStore, songStore } = getStore()
  storage.removeItem(storage.KEYS.userInfo)
  headerStore.updateUserDrawerVisible()
  userStore.updateUserConnectStatus(false)
  headerStore.updateTableListModalVisible(false)
  headerStore.updateRoomListModalVisible(false)
  songStore.updateChooseSongModalVisible(false)
  eventEmitter.emit(eventEmitter_KEYS.disconnect)
  storage.removeItem(storage.KEYS.connectTime)
}

async function recordConnectTime() {
  const now = new Date().getTime()
  await storage.setItem(storage.KEYS.connectTime, now)
}

export async function checkConnectExpire() {
  const connectTime = await storage.getItem(storage.KEYS.connectTime)
  const now = new Date().getTime()

  const timeDiff =
    (now - parseInt(connectTime as string, 10)) / (1000 * 60 * 60) // 时间差转换为小时

  // 如果时间差超过24小时，则认为登录已过期
  if (timeDiff >= 24) {
    userDisconnect()
    return false
  }

  return true
}
